// Mirror of backend `compliance_scrub` in /app/backend/seo_editor.py.
// Kept in sync manually. The SEO Editor Portal uses this to show the effective
// (post-scrub) length in the character counter so the editor never sees a
// "55/60 in UI but backend rejected as 68" discrepancy.
//
// If backend COMPLIANCE_AUTO_REPLACE changes, update this table too.

const COMPLIANCE_AUTO_REPLACE = [
  // Health / wellness flags
  [/\bback\s+pain\b/gi, "lower-back support requirements"],
  [/\bposture\s+correction\b/gi, "ergonomic seat geometry"],
  [/\bwellness\b/gi, "workspace quality"],
  [/\bemployee\s+health\b/gi, "workspace standards"],
  [/\bfatigue\b/gi, "extended-session use"],
  // Superlatives
  [/\bIndia['\u2019]s\s+(?:#?\s*1|number\s+one|leading|top|best|premier|biggest)\b/gi, "an established"],
  [/\bworld[- ]class\b/gi, "production-grade"],
  [/\b(?:the\s+)?leading\s+(?:manufacturer|brand|supplier)\b/gi, "a manufacturer"],
  [/\bmost\s+trusted\b/gi, "experienced"],
  [/\btrusted\s+by\s+\d+\+?\s*clients?\b/gi, "with multiple corporate clients"],
  // Absolute acoustic claims — order matters (specific → general)
  [/\b100%\s+soundproof\b/gi, "high acoustic attenuation"],
  [/\bcompletely\s+soundproof\b/gi, "acoustically attenuated"],
  [/\bsoundproof\b/gi, "acoustically attenuated"],
  // Indian English corrections
  [/\borganization\b/gi, "organisation"],
  [/\borganizations\b/gi, "organisations"],
  [/\bcenter\b/gi, "centre"],
  [/\bcenters\b/gi, "centres"],
  [/\boptimization\b/gi, "optimisation"],
  [/\boptimize\b/gi, "optimise"],
  [/\boptimized\b/gi, "optimised"],
  [/\bcolor\b/gi, "colour"],
  [/\bcolors\b/gi, "colours"],
  [/\bspecialize\b/gi, "specialise"],
  [/\bspecialized\b/gi, "specialised"],
  [/\bbehavior\b/gi, "behaviour"],
];

/**
 * Apply the same auto-replacements the backend applies before enforcing length limits.
 * Returns { scrubbed, replacements: [{ original, replacement }] }.
 */
export function previewCompliance(text) {
  if (!text) return { scrubbed: text || "", replacements: [] };
  let out = text;
  const replacements = [];
  for (const [pattern, replacement] of COMPLIANCE_AUTO_REPLACE) {
    const matches = out.match(pattern);
    if (matches) {
      for (const m of matches) {
        replacements.push({ original: m, replacement });
      }
      out = out.replace(pattern, replacement);
    }
  }
  return { scrubbed: out, replacements };
}
